<template>
	<page style="background: #fff;">
		<c-detail>
			<c-detail-item label="反馈类型"><b>{{baseInfo.suggestion_type ? '投诉' : '建议'}}</b></c-detail-item>
			<c-detail-item label="反馈内容">{{baseInfo.feedback_content}}</c-detail-item>
			<c-detail-item label="上传图片">
				<div class="flex-wrap" style="gap: .12rem;">
					<c-file-list :value="baseInfo.feedback_images"></c-file-list>
				</div>
			</c-detail-item>
		</c-detail>

		<cut-line v-if="baseInfo.reply_content"></cut-line>

		<dl v-if="baseInfo.reply_content" class="reply">
			<dt>平台回复：</dt>
			<dd v-html="baseInfo.reply_content"></dd>
		</dl>
	</page>
</template>

<script>
	export default {
		props: {
			id: String
		},

		data() {
			return {
				baseInfo: {}
			}
		},

		mounted() {
			this.request({
				url: '/complaint/suggestion/detail',
				data: {
					id: this.id
				},
				success: data => {
					this.baseInfo = data;
				}
			})
		}
	}
</script>

<style lang="stylus" scoped>
	.reply {
		padding: .2rem .32rem;

		dt {
			padding: 0 .1rem;
			line-height: .8rem;
			font-size: .32rem;
			font-weight: bold;
			color: #00ACA9;
		}

		dd {
			padding: .22rem .32rem;
			line-height: .44rem;
			font-size: .28rem;
			color: #333;
			background: #F9F9F9;
		}
	}
</style>